var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNewsGoodNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#21FF23",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3393,
    cy: 26.5,
    rx: 7.33929,
    ry: 7.5,
    fill: "#00A21F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5817 27.8726L28.3157 24.0565L28.8905 24.6435L24.5817 29.0466L21.9966 26.4048L22.571 25.8178L24.5817 27.8726Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNewsGoodNews);
export default __webpack_public_path__ + "static/media/noNewsGoodNews.26a2b2a524fbbc534f11652ad404ccc7.svg";
export { ForwardRef as ReactComponent };